import React, { useState, useEffect, useContext } from "react";
import { Spinner } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import ContabilidadReportesContext from "../../context/ContabilidadReportes/ContabilidadReportesContext";
import CatProductosContext from "../../context/CatProductos/CatProductosContext";
import ProveedoresContext from "../../context/Proveedores/ProveedoresContext";
import FabricantesContext from "../../context/Fabricantes/FabricantesContext";

import FiltroBusqueda from "../Filtros/FiltroBusqueda/FiltroBusqueda";

const ReporteVentas = () => {
  const [loading, setLoading] = useState(false);
  const [UISweetAlert, setUISweetAlert] = useState({
    success_dlg: false,
    reload_page: false,
    error_dlg: false,
    dynamic_title: "",
    dynamic_description: "",
  });

  const contabilidadReportesContext = useContext(ContabilidadReportesContext);
  const { setFiltrosReporteVentas, filtrosReporteVentas, exportReporteVentas } = contabilidadReportesContext;

  const ctxProductos = useContext(CatProductosContext);
  const { catProductos, listarCatProductos } = ctxProductos;

  const proveedoresContext = useContext(ProveedoresContext);
  const { listarProveedores, proveedores } = proveedoresContext;

  useEffect(() => {
    listarProveedores();
  }, []);

  const fabricantesContext = useContext(FabricantesContext);

  const { listarFabricantes, fabricantes } = fabricantesContext;

  useEffect(() => {
    listarFabricantes();
  }, []);

  useEffect(() => {
    listarCatProductos();
  });

  const filtrosVacios = {
    fechaInicial: "",
    fechaFinal: "",
    principioActivo: null,
    idCatProducto: null,
    idCatLaboratorio: null,
    idCatProveedor: null,
  };

  const buscarPorFiltros = async (e) => {
    e.preventDefault();

    setFiltrosReporteVentas(filtrosReporteVentas);
    generarReporte();
  };

  const generarReporte = async () => {
    setLoading(true);
    const res = await exportReporteVentas();
    if (res.data.error) {
      setLoading(false);
      setUISweetAlert({
        ...UISweetAlert,
        error_dlg: true,
        dynamic_title: "Fallo",
        dynamic_description: res.data.message,
      });
    }
    setLoading(false);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFiltrosReporteVentas({
      ...filtrosReporteVentas,
      [name]: value,
    });
  };

  const limpiarFiltros = () => {
    setFiltrosReporteVentas(filtrosVacios);
  };

  const opcionesProveedor = proveedores.map(({ idCatProveedor, proveedor, ...rest }) => ({
    ...rest,
    id: idCatProveedor,
    nombre: proveedor,
  }));

  const opcionesFabricante = fabricantes.map(({ idCatLaboratorio, laboratorio, ...rest }) => ({
    ...rest,
    id: idCatLaboratorio,
    nombre: laboratorio,
  }));

  const productosActivos = catProductos.map(({ idCatProducto, nombreComercial, ...medicamento }) => ({
    ...medicamento,
    id: idCatProducto,
    nombre: nombreComercial,
  }));

  const opcionesEstatus = [
    {
      id: "COBRADO",
      nombre: "COBRADO",
    },
    {
      id: "FACTURADO",
      nombre: "FACTURADO",
    },
  ];

  const inputCols = [
    {
      col: [
        {
          colType: "input",
          label: "Fecha Inicial",
          type: "date",
          name: "fechaInicial",
          disabled: false,
          value: filtrosReporteVentas.fechaInicial,
          onChange: onChange,
        },
        {
          colType: "input",
          label: "Principio Activo",
          name: "principioActivo",
          value: filtrosReporteVentas.principioActivo,
          type: "text",
          onChange: onChange,
        },
        {
          colType: "select",
          label: "Producto",
          name: "idCatProducto",
          value: filtrosReporteVentas.idCatProducto,
          opciones: productosActivos,
          onChange: onChange,
        },
        {
          colType: "select",
          label: "Fabricante (Laboratorio)",
          name: "idCatLaboratorio",
          value: filtrosReporteVentas.idCatLaboratorio,
          opciones: opcionesFabricante,
          onChange: onChange,
        },
      ],
    },
    {
      col: [
        {
          colType: "input",
          label: "Fecha Final",
          type: "date",
          name: "fechaFinal",
          disabled: !filtrosReporteVentas.fechaInicial ? true : false,
          min: filtrosReporteVentas.fechaInicial,
          value: filtrosReporteVentas.fechaFinal,
          onChange: onChange,
        },

        {
          colType: "select",
          label: "Proveedor",
          name: "idCatProveedor",
          value: filtrosReporteVentas.idCatProveedor,
          opciones: opcionesProveedor,
          onChange: onChange,
        },
        {
          colType: "select",
          label: "Estatus",
          name: "estatus",
          value: filtrosReporteVentas.estatus,
          opciones: opcionesEstatus,
          onChange: onChange,
        },
      ],
    },
  ];
  return (
    <div className="mt-8 container-fluid" style={{ textAlign: "left" }}>
      <h3 className="flex h3">Reporte de Ventas (Fabricante/Producto)</h3>
      <FiltroBusqueda
        toggleSearchBy={false}
        botonAplicar="Generar Reporte"
        buscarPorFiltros={buscarPorFiltros}
        onChange={onChange}
        limpiarFiltros={limpiarFiltros}
        paramsInput={inputCols}
      />
      {UISweetAlert.success_dlg ? (
        <SweetAlert
          success
          title={UISweetAlert.dynamic_title}
          onConfirm={() => {
            if (UISweetAlert.reload_page) {
              window.location.reload();
            }
            setUISweetAlert({
              ...UISweetAlert,
              success_dlg: false,
              reload_page: false,
            });
          }}>
          {UISweetAlert.dynamic_description}
        </SweetAlert>
      ) : null}

      {UISweetAlert.error_dlg ? (
        <SweetAlert
          error
          title={UISweetAlert.dynamic_title}
          onConfirm={() => {
            setUISweetAlert({
              ...UISweetAlert,
              error_dlg: false,
            });
          }}>
          {UISweetAlert.dynamic_description}
        </SweetAlert>
      ) : null}

      {loading ? (
        <SweetAlert title="Cargando!" showConfirm={false}>
          <Spinner />
        </SweetAlert>
      ) : null}
    </div>
  );
};

export default ReporteVentas;
